import {
  takeLatest
} from "redux-saga/effects";

import {
  defaultReturn,
  makePayload,
  generateDefaultActions,
  subKeySaga
} from "../utils/helpers";

const initialState = {
  portfolios: [],
  metricData: []
};

export const GET_PORTFOLIO_METRICS = generateDefaultActions("GET_PORTFOLIO_METRICS");

export default function portfoliosReducer(state = initialState, action) {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case GET_PORTFOLIO_METRICS.success:
      return defaultReturn(state, payload.data, "metricData");

    default:
      return state;
  }
}

export const getPortfolioMetrics = payload => makePayload(GET_PORTFOLIO_METRICS.value, payload);

// Saga
function* getPortfolioMetricsSaga(payload) {
  let url = "/metrics/portfolio";

  if (payload.companyId) {
    url = `${url}/${payload.companyId}`;
  }

  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(GET_PORTFOLIO_METRICS, url, "GET");
}

export function* portfolioSaga() {
  yield takeLatest(GET_PORTFOLIO_METRICS.value, getPortfolioMetricsSaga);
}
